import { render } from "./ForgotPasswordView2.vue?vue&type=template&id=cff1ae4e"
import script from "./ForgotPasswordView2.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordView2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__